<template>
  <div class="dashboard-layout d-flex flex-column min-vh-100">
    <!-- Navbar -->
    <NavbarView @toggle-sidebar="toggleSidebar" :sidebarOpen="sidebarOpen" />

    <!-- Sidebar -->
    <SidebarView
      :isOpen="sidebarOpen"
      @close-sidebar="closeSidebar"
      @select-page="selectPage"
    />

    <!-- Overlay (Mobile) -->
    <div
      v-if="sidebarOpen && !isDesktop"
      class="overlay"
      @click="closeSidebar"
    ></div>

    <!-- Main Content -->
    <main
      :class="[
        'content flex-grow-1',
        { 'content-shift': sidebarOpen && isDesktop },
      ]"
    >
      <!-- Conditional rendering based on selectedPage -->
      <section v-if="selectedPage === 'dashboard'">
        <StudentHome />
        <!-- Add dashboard cards, stats, etc. -->
      </section>

      <section v-if="selectedPage === 'videos'">
        <StudentVideos />
        <!-- Add video player or video list -->
      </section>

      <section v-if="selectedPage === 'profile'">
        <StudentProfile />
        <!-- Add profile form/details -->
      </section>

      <!-- Add more sections as needed -->
    </main>

    <!-- Footer -->
    <FooterView :sidebarOpen="sidebarOpen" />
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import NavbarView from "@/components/StudentDashboard/NavbarView.vue";
import SidebarView from "@/components/StudentDashboard/SidebarView.vue";
import FooterView from "@/components/StudentDashboard/FooterView.vue";
import StudentProfile from "./DashboardContent/StudentProfile.vue";
import StudentVideos from "./DashboardContent/StudentVideos.vue";
import StudentHome from "./DashboardContent/StudentHome.vue";

const sidebarOpen = ref(false);
const isDesktop = ref(window.innerWidth >= 992);

// Track selected page
const selectedPage = ref("dashboard"); // default page

// Toggle sidebar
const toggleSidebar = () => {
  sidebarOpen.value = !sidebarOpen.value;
};
const closeSidebar = () => {
  sidebarOpen.value = false;
};

// Handle page selection from sidebar
const selectPage = (page) => {
  selectedPage.value = page;
  // close sidebar on mobile
  if (!isDesktop.value) sidebarOpen.value = false;
};

// Handle window resize
const handleResize = () => {
  isDesktop.value = window.innerWidth >= 992;
  if (!isDesktop.value) sidebarOpen.value = false;
};

onMounted(() => window.addEventListener("resize", handleResize));
onUnmounted(() => window.removeEventListener("resize", handleResize));
</script>

<style scoped>
.dashboard-layout {
  background: #0d0015;
  color: white;
}

/* Content */
.content {
  transition: margin-left 0.3s ease;
  margin-left: 0;
  padding: 6px;
}

.content-shift {
  margin-left: 250px;
}

/* Overlay */
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1039;
}

/* Footer */
.axion-footer {
  background: #000;
  border-top: 1px solid #ff00cc;
  color: #aaa;
}

section {
  padding-top: 45px;
}
</style>
